export default __webpack_public_path__ + "static/media/cc-zero.871ab7c3.svg";